import { SentryFeatureTags, logException } from "@punchup/sentry";
import {
  VENUE_PAGE_SHOWS_PREFETCH_LIMIT,
  getCachedVenuePageShows,
} from "../../server/venuePageCache";

import { QueryClient } from "@tanstack/react-query";
import type { VenuePageTimezones } from "@punchup/data/models";

/**
 * Prefetch venue page shows for server-side rendering. Feeds the carousel hook
 * and the "Upcoming shows" list via the ["venueShows"] query.
 */
export async function prefetchVenuePageShows(
  queryClient: QueryClient,
  venuePageId: string,
  venueTimezones: VenuePageTimezones,
  limit: number = VENUE_PAGE_SHOWS_PREFETCH_LIMIT
) {
  await queryClient.prefetchQuery({
    queryKey: ["venueShows", venuePageId],
    queryFn: async () => {
      try {
        return await getCachedVenuePageShows(venuePageId, venueTimezones, {
          limit,
        });
      } catch (error) {
        logException(error as Error, {
          extra: {
            data: "Error fetching venue shows in prefetchVenuePageShows",
          },
          tags: {
            feature: SentryFeatureTags.VenuePages,
            venuePageId,
          },
        });
        throw error;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
